//@ts-check
import {Dropdown, Modal} from '@/components/atoms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useCategoryList} from '@/hooks/useCategoryList'
import {useState} from 'react'

export const RouteTypeDropown = () => {
  const {productCombo, updateProductCombo} = useProductCombo()
  const {categoryListData: routeTypesList, isLoading} = useCategoryList('routetype', true)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [pendingRouteTypeId, setPendingRouteTypeId] = useState(null)

  const routeTypeOptions = routeTypesList.map(routeType => ({
    id: routeType.id,
    displayText: routeType.value,
  }))

  const handleUpdateValue = values => {
    const selectedValue = values[0] || null
    if (selectedValue) {
      // If there's already a route type selected and user is changing it, show confirmation
      if (productCombo?.routeTypeId && productCombo?.routeTypeId !== selectedValue.id) {
        setPendingRouteTypeId(selectedValue.id)
        setShowConfirmationModal(true)
      } else if (!productCombo?.routeTypeId) {
        // First time selection, no need for confirmation
        updateProductCombo({routeTypeId: selectedValue.id, comboSkus: [], displayCategories: [], displayCategoryIds: []})
      }
    }
  }

  const handleConfirmRouteTypeChange = () => {
    if (pendingRouteTypeId) {
      updateProductCombo({routeTypeId: pendingRouteTypeId, comboSkus: [], displayCategories: [], displayCategoryIds: []})
      setShowConfirmationModal(false)
      setPendingRouteTypeId(null)
    }
  }

  const handleCancelRouteTypeChange = () => {
    setShowConfirmationModal(false)
    setPendingRouteTypeId(null)
  }

  const selectedRouteType = productCombo?.routeTypeId
    ? routeTypeOptions.find(option => option.id === productCombo.routeTypeId) || null
    : null

  return (
    <>
      <Dropdown
        label="Route Type ID*"
        isJsonWrap={false}
        childList={routeTypeOptions}
        updateValue={handleUpdateValue}
        loading={isLoading}
        value={selectedRouteType ? [selectedRouteType] : []}
        selection="single"
        autoComplete="off"
        menuPosition="top-right"
      />
      <Modal
        showModal={showConfirmationModal}
        title={"Changing the Route Type will reset the Product List"}
        text={"If you change the route type, the current product list in this combo will be cleared. Do you want to continue?"}
        primaryButtonText="Yes"
        secondaryButtonText="No"
        showSecondaryButton={true}
        classNameWrapper="min-h-80"
        onClickSecondaryButton={handleCancelRouteTypeChange}
        onClickPrimaryButton={handleConfirmRouteTypeChange}
        hideCloseButton={true}
      />
    </>
  )
}
